import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUserGroup } from "@fortawesome/pro-regular-svg-icons"
import "react-tippy/dist/tippy.css"
import { Tooltip } from "react-tippy"
import { NameWithIcon } from "./styles"
import { toBool } from "../../../utils/stringHelpers"

const EmployerUserNameCell = ({
  value,
  row: {
    original: { can_manage_users }
  }
}) => {
  return (
    <NameWithIcon>
      <span>{value}</span>
      {toBool(can_manage_users) && (
        <Tooltip title={`Can manage users`}>
          <FontAwesomeIcon icon={faUserGroup} size="sm" />
        </Tooltip>
      )}
    </NameWithIcon>
  )
}

export default EmployerUserNameCell
